module.exports = __webpack_public_path__ + "img/1-Uso de suelo.e9853262.jpg";